import React, {
  useEffect,
  useState,
} from "react";

import serviceTicketService
  from "../../services/serviceTicketService";

export default function ServiceTicketViewDrawer({

  open,

  ticketId,

  onClose,

}) {

  const [loading, setLoading] =
    useState(false);

  const [ticket, setTicket] =
    useState(null);

const [feedback, setFeedback] =
  useState(null);

  // ==========================================================
  // LOAD TICKET
  // ==========================================================

  useEffect(() => {

  if (
    open &&
    ticketId
  ) {

    loadTicket();

    loadFeedback();
  }

}, [
  open,
  ticketId,
]);

  async function loadTicket() {

    try {

      setLoading(true);

      const res =
        await serviceTicketService
          .getTicket(ticketId);

      setTicket(res);

    } catch (err) {

      console.error(
        "Failed to load ticket",
        err
      );

    } finally {

      setLoading(false);
    }
  }
async function loadFeedback() {

  try {

    const res =
      await serviceTicketService
        .getFeedback(ticketId);

    console.log(
      "Feedback Response",
      res
    );

    setFeedback(res);

  } catch (err) {

    console.error(
      "Failed to load feedback",
      err
    );
  }
}
  // ==========================================================
  // CLOSE
  // ==========================================================

  if (!open) {

    return null;
  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      style={{
        position: "fixed",
        inset: 0,
        background:
          "rgba(0,0,0,0.35)",
        zIndex: 99999,
      }}
    >

      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          width: "75%",
          height: "100%",
          background: "#fff",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >

        {/* ====================================================== */}
        {/* HEADER */}
        {/* ====================================================== */}

        <div
          style={{
            padding: 20,
            borderBottom:
              "1px solid #dee2e6",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
          }}
        >

          <div>

            <h3
              style={{
                margin: 0,
              }}
            >
              Ticket Details
            </h3>

            <div
              style={{
                color: "#6c757d",
                marginTop: 4,
              }}
            >
              Ticket ID :
              {" "}
              {ticketId}
            </div>

          </div>

          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>

        </div>

        {/* ====================================================== */}
        {/* BODY */}
        {/* ====================================================== */}

        <div
          style={{
            padding: 20,
            flex: 1,
          }}
        >

          {loading && (

            <div>
              Loading ticket...
            </div>

          )}

          {!loading &&
            !ticket && (

            <div>
              No ticket found
            </div>

          )}

          {!loading &&
            ticket && (

            <>

              {/* ============================================== */}
              {/* TICKET OVERVIEW */}
              {/* ============================================== */}

              <div
                style={{
                  background: "#fff",
                  border:
                    "1px solid #dee2e6",
                  borderRadius: 10,
                  padding: 20,
                  marginBottom: 20,
                }}
              >

                <h4
                  style={{
                    marginTop: 0,
                  }}
                >
                  Ticket Overview
                </h4>

                <table
                  className="table"
                >

                  <tbody>

                    <tr>
                      <td>Ticket No</td>
                      <td>
                        {ticket.ticket_no || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Status</td>
                      <td>
                        {ticket.status || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>SR Type</td>
                      <td>
                        {ticket.sr_type || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Priority</td>
                      <td>
                        {ticket.priority || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Category</td>
                      <td>
                        {ticket.category || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Created At</td>
                      <td>
                        {ticket.created_at || "-"}
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

              {/* ============================================== */}
              {/* CUSTOMER & PRODUCT */}
              {/* ============================================== */}

              <div
                style={{
                  background: "#fff",
                  border:
                    "1px solid #dee2e6",
                  borderRadius: 10,
                  padding: 20,
                  marginBottom: 20,
                }}
              >

                <h4
                  style={{
                    marginTop: 0,
                  }}
                >
                  Customer & Product Information
                </h4>

                <table
                  className="table"
                >

                  <tbody>

                    <tr>
                      <td>Customer</td>
                      <td>
                        {ticket.customer_name || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Contact Person</td>
                      <td>
                        {ticket.contact_person || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Mobile</td>
                      <td>
                        {ticket.contact_number || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Instance ID</td>
                      <td>
                        {ticket.instance_id || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>App Code</td>
                      <td>
                        {ticket.engine_app_code || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>Engine Serial No</td>
                      <td>
                        {ticket.engine_serial_no || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>State</td>
                      <td>
                        {ticket.state || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td>City</td>
                      <td>
                        {ticket.city || "-"}
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

              {/* ============================================== */}
              {/* COMPLAINT DETAILS */}
              {/* ============================================== */}

              <div
                style={{
                  background: "#fff",
                  border:
                    "1px solid #dee2e6",
                  borderRadius: 10,
                  padding: 20,
                  marginBottom: 20,
                }}
              >

                <h4
                  style={{
                    marginTop: 0,
                  }}
                >
                  Complaint Details
                </h4>

                <div
                  style={{
                    marginBottom: 20,
                  }}
                >

                {/* ============================================== */}
                {/* ASSIGNMENT INFORMATION */}
                {/* ============================================== */}

                <div
                style={{
                    background: "#fff",
                    border: "1px solid #dee2e6",
                    borderRadius: 10,
                    padding: 20,
                    marginBottom: 20,
                }}
                >

                <h4
                    style={{
                    marginTop: 0,
                    }}
                >
                    Assignment Information
                </h4>

                <table className="table">

                    <tbody>

                    <tr>
                        <td>Engineer</td>
                        <td>
                        {ticket.engineer_name || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Dealer</td>
                        <td>
                        {ticket.dealer_name || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Plant</td>
                        <td>
                        {ticket.plant_name || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Assigned At</td>
                        <td>
                        {ticket.assigned_at || "-"}
                        </td>
                    </tr>

                    </tbody>

                </table>

                </div>
                {(
                ticket.resolution_summary ||
                ticket.resolved_at
                ) && (

                <div
                style={{
                    background: "#fff",
                    border: "1px solid #dee2e6",
                    borderRadius: 10,
                    padding: 20,
                    marginBottom: 20,
                }}
                >

                <h4
                    style={{
                    marginTop: 0,
                    }}
                >
                    Resolution Information
                </h4>

                <table className="table">

                    <tbody>

                    <tr>
                        <td>Resolution Summary</td>
                        <td>
                        {ticket.resolution_summary || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Resolved At</td>
                        <td>
                        {ticket.resolved_at || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Resolved By</td>
                        <td>
                        {ticket.resolved_by_name || "-"}
                        </td>
                    </tr>

                    </tbody>

                </table>

                </div>

                )}
                {(
                ticket.closed_at ||
                ticket.closure_remarks
                ) && (

                <div
                style={{
                    background: "#fff",
                    border: "1px solid #dee2e6",
                    borderRadius: 10,
                    padding: 20,
                    marginBottom: 20,
                }}
                >

                <h4
                    style={{
                    marginTop: 0,
                    }}
                >
                    Closure Information
                </h4>

                <table className="table">

                    <tbody>

                    <tr>
                        <td>Closed At</td>
                        <td>
                        {ticket.closed_at || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Closure Remarks</td>
                        <td>
                        {ticket.closure_remarks || "-"}
                        </td>
                    </tr>

                    <tr>
                        <td>Closed By</td>
                        <td>
                        {ticket.closed_by_name || "-"}
                        </td>
                    </tr>

                    </tbody>

                </table>

                </div>

                )}
                {/* ============================================== */}
            {/* CUSTOMER FEEDBACK */}
            {/* ============================================== */}

            <div
            style={{
                background: "#fff",
                border: "1px solid #dee2e6",
                borderRadius: 10,
                padding: 20,
                marginBottom: 20,
            }}
            >

            <h4
                style={{
                marginTop: 0,
                }}
            >
                Customer Feedback
            </h4>

            <table
                className="table"
            >

                <tbody>

                <tr>
                    <td>
                    Feedback %
                    </td>

                    <td>
                    {
                        feedback?.feedback_percentage
                        || 0
                    }%
                    </td>
                </tr>

                <tr>
                    <td>
                    Feedback Status
                    </td>

                    <td>
                    {
                        feedback?.feedback_status
                        || "-"
                    }
                    </td>
                </tr>

                <tr>
                    <td>
                    Customer Remarks
                    </td>

                    <td>
                    {
                        feedback?.comments
                        || "-"
                    }
                    </td>
                </tr>

                </tbody>

            </table>

            </div>

                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 6,
                    }}
                  >
                    VOC Details
                  </div>

                  <div>
                    {ticket.voc_details || "-"}
                  </div>

                </div>

                <div>

                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 6,
                    }}
                  >
                    Additional Notes
                  </div>

                  <div>
                    {ticket.complaint_details || "-"}
                  </div>

                </div>

              </div>

            </>

          )}

        </div>

      </div>

    </div>
  );
}